import { render, staticRenderFns } from "./ImgGroupUpload.vue?vue&type=template&id=4d4369f8&"
import script from "./ImgGroupUpload.vue?vue&type=script&lang=js&"
export * from "./ImgGroupUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImgGroupUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports